import { ShutdownModal } from '@/features/shutdown-notice'

// Loki.build is paused. The app boots straight into the non-closable shutdown
// notice — no router, providers, auth, data fetching, or analytics run behind it.
// To restore the full app, revert this file (see git history) to render
// <BrowserRouter><Providers><Pages /></Providers></BrowserRouter>.
export default function App() {
  return <ShutdownModal />
}
